import React, {PureComponent} from "react";
import IconTitle from "../../components/iconTitle";
import {faList, faSmileWink, faSpinner} from "@fortawesome/pro-solid-svg-icons";
import {Get} from "../../components/request";
import DivTable from "../../components/divTable";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class PAE extends PureComponent {
    state = {
        loading: false,
        list: []
    }

    async componentDidMount() {
        await this.search();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search && this.props.search !== 0) {
            await this.search();
        }
    }

    async search() {
        this.setState({
            loading: true,
            list: [],
            date: "",
            valide: "",
            ECTSIncompletDemandeEtudiant: false,
        });

        const {body} = await Get(`/v1/extranet/verifications/${this.props.search}/PAE`);

        setTimeout(() => this.setState({
            loading: false,
            list: body.result,
            date: body.date,
            valide: body.valide,
            ECTSIncompletDemandeEtudiant: body.ECTSIncompletDemandeEtudiant
        }), 250);
    }

    render() {
        return (
            <section>
                <IconTitle icon={faList} type={"h3"} content={"Programme Annuel Effectif"}/>
                {this.state.list.length > 0 ?
                    <>
                        <DivTable columns={{
                            'Code UE': 'UniteEnseignementSourceCode',
                            'Libelle UE': 'UniteEnseignementLibelle',
                            'Nombre d\'ECTS': "UniteEnseignementNbECTS"
                        }}
                                  array={this.state.list}/>
                        <br/>
                        <h5 className={"float-right mr-3 pr-5"}><u>Total
                            ECTS</u>: {this.state.list.reduce((a, b) => a + b.UniteEnseignementNbECTS, 0)}
                        </h5>
                        <br/>
                        <br/>
                        {this.state.ECTSIncompletDemandeEtudiant && <p>L'étudiant a explicitement fait la demande d'un PAE à moins de 60 crédits</p>}
                        <p>
                            {this.state.date !== null && "Signé en ligne par l'étudiant en date du " + this.state.date}
                        </p>
                        <p>
                            {this.state.valide !== null && "PAE validé par le coordinateur du programme en date du " + this.state.valide}
                        </p>
                    </>
                    :
                    <div style={{marginLeft: "4.5rem"}}>
                        {this.state.loading
                            ? <FontAwesomeIcon icon={faSpinner} className={"fa-3x"} pulse={true}/>
                            : <IconTitle type={"h6"} classContent={"ml-1 pl-1"}
                                         icon={faSmileWink} content={"PAE vide"}/>}
                    </div>}
            </section>
        );
    }
}

export default PAE;